import {inject, type InjectionKey, provide} from 'vue';

const ModalFunctionsKey: InjectionKey<{
  openModal: (id: string) => void;
  closeModal: (id: string) => void;
}> = Symbol('ModalFunctions');

export function provideModalFunctions() {
  const openModal = (id: string): void => {
    document.getElementById(`open-${id}`)?.click();
  }
  const closeModal = (id: string): void => {
    document.getElementById(`close-${id}`)?.click();
  }

  provide(ModalFunctionsKey, {openModal, closeModal});
}

export function useModal() {
  const modalFunctions = inject(ModalFunctionsKey);

  if (!modalFunctions) {
    throw new Error('Modal functions not provided!');
  }

  return modalFunctions;
}
